import { render, staticRenderFns } from "./LastLbMetaDataTab.vue?vue&type=template&id=9e771076"
import script from "./LastLbMetaDataTab.vue?vue&type=script&lang=js"
export * from "./LastLbMetaDataTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports